"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  paper: ({
    theme
  }) => ({
    '&.OriSelectPaper': {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: theme.shape.borderRadius,
      marginTop: theme.spacing(1)
    }
  })
};
var _default = exports.default = {
  styleOverrides
};
